import React, { memo, useCallback } from 'react';
import { getActivityIcon } from '../../../../utils/get-prospect-icon';
import MasterLog from '../../../../enums/master-log-enum';
import IconAndLog from '../../atoms/icon-and-log';
import { sanitizeRichText } from '../../../../utils/sanitize-rich-text';

const getIconForActivity = (key: MasterLog) => getActivityIcon(key);

const ActivityComponent = ({ dayText, activity }) => {
  const parsedActivityLog = useCallback(
    (log: string): string => sanitizeRichText(log),
    [],
  );

  return (
    <div className="mt-4 log-activity">
      <span className="day-text">{dayText}</span>

      {activity?.map((activityObj: { log?: string; key: MasterLog }) => {
        const parsed = parsedActivityLog(activityObj?.log || '');
        return (
          <IconAndLog
            key={activityObj.key}
            icon={getIconForActivity(activityObj.key)}
            log={parsed}
            type={activityObj.key}
          />
        );
      })}
    </div>
  );
};

export default memo(ActivityComponent);
